<template>
  <div>
    <el-input
      clearable
      type="text"
      placeholder="Search profile..."
      v-model="identifier"
      @clear="reset"
      @keyup.enter.native="searchProfile"
    >
      <template #append>
        <el-button @click.native="searchProfile" :disabled="!canSearch || loading">
          <i :class="loading ? 'el-icon-loading' : 'el-icon-search'"></i> Search Profile
        </el-button>
      </template>
    </el-input>
  </div>
</template>

<script>

export default {
  name: 'IdentifiersFilter',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    identifier: '',
  }),
  computed: {
    canSearch() {
      return this.identifier.trim() !== '';
    },
  },
  watch: {
    identifier(value) {
      if (!value) {
        this.reset();
      }
    },
  },
  methods: {
    reset() {
      this.clearSearch();
    },
    searchProfile() {
      if (this.canSearch) {
        this.$emit('search-profile', this.identifier);
      }
    },
    clearSearch() {
      this.identifier = '';
      this.$emit('search-profile', this.identifier);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// IdentifierFilter.vue?727d0622